import type { SnapshotOut } from 'mobx-state-tree';
import { types } from 'mobx-state-tree';

import { CreditCardModel } from './credit-card';

/**
 * Order Request model.
 */
export const CustomerModel = types.model('Customer', {
  card: types.maybeNull(CreditCardModel),
  creditCards: types.array(CreditCardModel),
  email: types.string,
  firstName: types.string,
  fullName: types.string,
  hasPhone: types.optional(types.boolean, false),
  id: types.maybeNull(types.string),
  lastName: types.maybeNull(types.string),
  phone: types.string,
  postalCode: types.string,
});

type CustomerSnapshotType = SnapshotOut<typeof CustomerModel>;
export type CustomerSnapshot = CustomerSnapshotType;
